import { getPresignedDownloadUrl } from '@/api/documents'
import { useSnackbar } from '@/providers/SnackbarProvider'
import { Button } from '@surein/ui'
import { Download } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type DownloadCellProps = {
  companyId: string
  fileId: string
}

const DownloadCell = ({ companyId, fileId }: DownloadCellProps) => {
  const { t } = useTranslation()
  const snackbar = useSnackbar()

  const handleDownload = async () => {
    try {
      const response = await getPresignedDownloadUrl(companyId, fileId)

      if (response.status !== 200 || !response.data) {
        snackbar.error(t('snackbars.error.failedToGetPresignedDownloadUrl'))
        return
      }

      window.open(response.data.url, '_blank', 'noopener,noreferrer')
    } catch (error) {
      snackbar.error(t('snackbars.error.generalMsg'))
      console.error(error)
    }
  }

  return (
    <Button variant="ghost" onClick={handleDownload}>
      <Download size={20} />
    </Button>
  )
}

export default DownloadCell
